<template>
  <el-dialog
    title="快递模板配置"
    :visible.sync="visible"
    width="640px"
    append-to-body
    @closed="handleClosed">
    <div class="">
      <el-form
        ref="ruleForm"
        label-width="100px"
        :rules="rules"
        :model="ruleForm">
        <el-form-item
          label="物流公司：">
          {{ ruleForm.expressName }}
        </el-form-item>
        <el-form-item
          label="模板名称："
          prop="expressTempletName">
          <el-input
            v-model="ruleForm.expressTempletName"
            placeholder="请输入客户编码"></el-input>
        </el-form-item>
        <el-form-item
          label="客户编码："
          prop="customerName">
          <el-input
            v-model="ruleForm.customerName"
            placeholder="请输入客户编码"></el-input>
        </el-form-item>
        <el-form-item
          label="支付方式："
          prop="payType">
          <el-select
            v-model="ruleForm.payType"
            style="width: 100%"
            placeholder="请选择">
            <el-option
              v-for="item in PayType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="客户密钥："
          prop="customerPassword">
          <el-input
            v-model="ruleForm.customerPassword"
            placeholder="请输入客户密钥"></el-input>
        </el-form-item>
        <el-form-item
          label="月结号："
          prop="monthCode">
          <el-input
            v-model="ruleForm.monthCode"
            placeholder="请输入月结号"></el-input>
        </el-form-item>
        <el-form-item
          label="所属网点："
          prop="sendSite">
          <el-input
            v-model="ruleForm.sendSite"
            placeholder="请输入所属网点"></el-input>
        </el-form-item>
        <el-form-item
          label="快递员："
          prop="sendStaff">
          <el-input
            v-model="ruleForm.sendStaff"
            placeholder="请输入快递员"></el-input>
        </el-form-item>
        <el-form-item
          label="物流方式："
          prop="transType">
          <el-radio-group v-model="ruleForm.transType">
            <el-radio-button :label="1">陆运</el-radio-button>
            <el-radio-button :label="2">空运</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="模板来源："
          prop="printingPlatform">
          <el-radio-group v-model="ruleForm.printingPlatform">
            <el-radio-button :label="3">快递鸟</el-radio-button>
            <el-radio-button :label="4">抖店</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="模板地址："
          prop="templateUrl">
          <el-input
            v-model="ruleForm.templateUrl"
            placeholder="请输入模板地址"></el-input>
        </el-form-item>
        <el-form-item
          label="发件人："
          prop="senderName">
          <el-input
            v-model="ruleForm.senderName"
            placeholder="请输入发件人"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号："
          prop="senderPhone">
          <el-input
            v-model="ruleForm.senderPhone"
            placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item
          label="省份："
          prop="senderProvinceName">
          <el-input
            v-model="ruleForm.senderProvinceName"
            placeholder="请输入省份"></el-input>
        </el-form-item>
        <el-form-item
          label="城市："
          prop="senderCityName">
          <el-input
            v-model="ruleForm.senderCityName"
            placeholder="请输入城市"></el-input>
        </el-form-item>
        <el-form-item
          label="区县："
          prop="senderAreaName">
          <el-input
            v-model="ruleForm.senderAreaName"
            placeholder="请输入区县"></el-input>
        </el-form-item>
        <el-form-item
          label="街道："
          prop="senderStreetName">
          <el-input
            v-model="ruleForm.senderStreetName"
            placeholder="请输入街道"></el-input>
        </el-form-item>
        <el-form-item
          label="详细地址："
          prop="senderAddress">
          <el-input
            v-model="ruleForm.senderAddress"
            placeholder="请输入详细地址"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        :loading="loading"
        type="primary"
        @click="addItem">保存</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
// import VendorOrderSourceCheckbox from '../../../components/business/vendor-order-source-checkbox.vue'
import { PayType } from '../../../utils/index'
export default {
  name: 'TemplateEditModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      PayType,
      ruleForm: {
        // vendorId: null,
        expressId: null,
        expressCode: '',
        expressTempletName: '',
        payType: 1,
        customerName: '',
        customerPassword: '',
        monthCode: '',
        sendSite: '',
        sendStaff: '',
        transType: 1, // 1 陆运2 空运
        senderName: '',
        senderPhone: '',
        senderProvinceName: '',
        senderCityName: '',
        senderAreaName: '',
        senderAddress: '',

        expressName: null,
        kdnExpressCode: null,

        printingPlatform: 3,
        templateUrl: '',
        senderStreetName: ''
      },
      rules: {
        // orderSources: [
        //   { type: 'array', required: true, message: '请选择订单来源', trigger: 'change' }
        // ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.ruleForm = {
        expressId: null,
        expressCode: '',
        expressTempletName: '',
        payType: 1,
        customerName: '',
        customerPassword: '',
        monthCode: '',
        sendSite: '',
        sendStaff: '',
        transType: 1, // 1 陆运2 空运
        senderName: '',
        senderPhone: '',
        senderProvinceName: '',
        senderCityName: '',
        senderAreaName: '',
        senderAddress: '',

        expressName: null,
        kdnExpressCode: null
      }
    },
    fetch(row) {
      this.ruleForm = {
        ...this.ruleForm,
        ...row
      }
      this.toggleModal(true)
    },
    addItem() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('vendor/setvendorexpress', {
            payload: {
              vendorExpresses: [this.ruleForm],
              operFlag: this.ruleForm.expressId ? 'upd' : 'add' // add del upd
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
